module.exports = __webpack_public_path__ + "img/ua.627ef713.svg";